import { all, spawn } from "redux-saga/effects";
import * as exhibitions from "./exhibitions";
import * as nows from "./nows";
import * as contents from "./contents";

function* rootSaga() {
   yield all([
      ...Object.keys(exhibitions).map((k: string) => spawn(exhibitions[k as keyof typeof exhibitions])),
      ...Object.keys(nows).map((k: string) => spawn(nows[k as keyof typeof nows])),
      ...Object.keys(contents).map((k: string) => spawn(contents[k as keyof typeof contents])),
   ]);
}

export default rootSaga;
